// pages/auth/Confirm.js
import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../../services/api';

function Confirm() {
  const [searchParams] = useSearchParams();
  const [hasCompany, setHasCompany] = useState(false);
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const checkToken = async () => {
      try {
        const token = searchParams.get('token');
        const res = await api.post('/auth/confirm', { token });
        setHasCompany(res.data.hasCompany);
      } catch {
        setMessage('Invalid or expired token');
      }
    };
    checkToken();
  }, [searchParams]);

  const handleConfirm = async () => {
    if (password !== password2) {
      setMessage('Passwords do not match');
      return;
    }
    try {
      const token = searchParams.get('token');
      const res = await api.post('/auth/finalize', {
        token,
        name,
        surname,
        password,
        companyName
      });
      setMessage(res.data.message);
    } catch (err) {
      setMessage(err.response?.data?.error || 'Error');
    }
  };

  return (
    <div className="page-container">
      <h2>Confirmation</h2>
      {!hasCompany && (
        <div className="form-group">
          <label>Company Name</label>
          <input 
            type="text"
            placeholder="Enter your company name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </div>
      )}
      <div className="form-group">
        <label>Name</label>
        <input 
          type="text"
          placeholder="Enter your name"
          value={name}
          onChange={(e) => setName(e.target.value)} 
        />
      </div>
      <div className="form-group">
        <label>Surname</label>
        <input 
          type="text"
          placeholder="Enter your surname"
          value={surname}
          onChange={(e) => setSurname(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>Password</label>
        <input 
          type="password"
          placeholder="Enter a new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)} 
        />
      </div>
      <div className="form-group">
        <label>Repeat Password</label>
        <input 
          type="password"
          placeholder="Confirm your password"
          value={password2}
          onChange={(e) => setPassword2(e.target.value)} 
        />
      </div>
      <button className="btn" onClick={handleConfirm}>Confirm</button>
      {message && <p className="mt-1">{message}</p>}
    </div>
  );
}

export default Confirm;